import script from "./SelectDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SelectDropdown.vue?vue&type=style&index=0&id=28ddd74e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ddd74e"]])

export default __exports__